export default __webpack_public_path__ + "static/media/ITALIC_unpressed.0db92319.svg";